import { useToast } from 'fire-iot-ui-template'

/**
 * 全局 Toast 单例。
 *
 * fire-iot-ui-template 的 useToast() 每次调用会创建独立的 toasts 状态，
 * 为了让 App.vue、axios 拦截器、路由守卫以及各业务视图共享同一组 toast，
 * 在模块顶层只实例化一次并导出。
 */
export const toast = useToast()
